export default "__VITE_ASSET__B5aB3P6d__"